import { createContext, useContext } from 'react';
/**
 * ADR-141 D1.1 — the funnel-step seam, in its own module for the same reason
 * `ClientEventContext` is: the consumers are leaves. Two of the four tokens fire
 * inside the chat screen, which is exactly the component that should not gain an
 * import edge to `ApiProvider` (and through it to the transport and the
 * conversation directory) to reach one `createContext` call.
 *
 * ⛔ THE CONTEXT EXPOSES A CALL, NEVER A TRANSPORT. `ReportFunnelStep` takes a
 * token and returns nothing; the collector URL, the website id, the empty
 * `title`/`referrer` and the never-retry rule all stay inside `routeViewSender.ts`,
 * which is the module ADR-141 D1.1 names as the enforcement point. That is what
 * makes a second sender not "sending from elsewhere" (architect R3, 2026-09-02) —
 * a consumer that could construct its own send would be.
 *
 * Default is a no-op, matching `ClientEventContext`, and for the same reason:
 * telemetry is the subsystem whose absence must never break the surface it
 * observes, and an isolated chat-component test should not have to mount a
 * provider to render.
 *
 * ⚠️ Same cost as its sibling, restated because it is easy to forget per-context: a
 * MISSING provider is indistinguishable from a working one that dropped the step.
 * Nothing in the app can tell them apart. The guard is a test asserting the
 * provider supplies a NON-DEFAULT value — a funnel that silently measures nothing
 * looks exactly like a funnel measuring zero conversions, which is the failure mode
 * a reader is most likely to believe.
 */
export const FunnelStepContext = createContext(() => { });
export function useReportFunnelStep() {
    return useContext(FunnelStepContext);
}
//# sourceMappingURL=FunnelStepContext.js.map